import type { Control, FieldPath, FieldValues, UseControllerProps } from 'react-hook-form';
import { useController } from 'react-hook-form';

type RangeFormFieldProps<
  TFieldValues extends FieldValues,
  TFieldPath extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  control: Control<TFieldValues>;
  fieldPath: TFieldPath;
  min: number;
  max: number;
  step?: number;
  containerClassName?: string;
  className?: string;
  rules?: UseControllerProps<TFieldValues, TFieldPath>['rules'];
};

export const RangeFormField = <
  TFieldValues extends FieldValues,
  TFieldPath extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  control,
  fieldPath,
  min,
  max,
  step,
  containerClassName,
  className,
  rules,
}: RangeFormFieldProps<TFieldValues, TFieldPath>) => {
  const {
    field: { name, onChange, ref, value },
  } = useController({ name: fieldPath, control, rules });

  return (
    <div className={containerClassName || ''}>
      <input
        type='range'
        min={min}
        max={max}
        step={step}
        ref={ref}
        name={name}
        onChange={onChange}
        value={value}
        className={`form-input ${className ?? ''}`}
      />
      <span className='text-xs text-gray-500'>{value}</span>
    </div>
  );
};
